// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__22kkf","ranges":"BmiRanges_ranges__2bQ19"};